import { render, staticRenderFns } from "./booklet-page.vue?vue&type=template&id=4121773a"
import script from "./booklet-page.vue?vue&type=script&lang=ts"
export * from "./booklet-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports